import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import http from "../services/http";

const useNotifications = (user) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const notificationInterval = 15 * 60000; // 1 * 60000 = 1 Minute
    async function getNotifications() {
      try {
        const { data } = await http.get("/notifications");
        setNotifications(data);
      }
      catch {
        //ignore error
      }
    }

    if (!user) return;
    getNotifications();
    const interval = setInterval(() => {
      getNotifications();
    }, notificationInterval);

    return () => clearInterval(interval);
  }, [user]);

  const handleRead = async (notification) => {
    const newStatus = !notification.IS_READ;

    try {
      await http.patch(`/notifications/${notification.ID}`, {
        read: newStatus,
      });
      const index = notifications.findIndex((n) => n.ID === notification.ID);
      const newNotifications = [...notifications];
      newNotifications[index].IS_READ = newStatus;
      setNotifications(newNotifications);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  };

  const handleReadAll = async () => {
    const newNotifications = [...notifications];
    newNotifications.map((n) => (n.IS_READ = true));
    setNotifications(newNotifications);
    try {
      await http.patch(`/notifications/read-all`);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  };

  const handleClearAll = async () => {
    try {
      await http.delete(`/notifications`);
      setNotifications([]);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  };

  const handleDelete = async (notification) => {
    const oldNotifications = [...notifications];
    setNotifications(notifications.filter((n) => n.ID !== notification.ID));
    try {
      await http.delete(`/notifications/${notification.ID}`);
    } catch (ex) {
      setNotifications(oldNotifications);
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  };

  const handleRefresh = async () => {
    try {

      const { data } = await http.get("/notifications");
      setNotifications(data);
    }
    catch {
      //ignore error
    }
  };

  return {
    notifications,
    handleRead,
    handleReadAll,
    handleDelete,
    handleClearAll,
    handleRefresh,
  };
};

export default useNotifications;
